import { Icon } from "@mdi/react";

import { mdiInformation } from "@mdi/js";
import styled from "styled-components";

interface IColorPickerWarningMessage {
  message: string;
}

export default function ColorPickerWarningMessage({
  message
}: IColorPickerWarningMessage) {
  return (
    <WarningMessageContainer>
      <Icon path={mdiInformation} size={"16px"} />
      {message}
    </WarningMessageContainer>
  );
}

const WarningMessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 18px 5px 10px;
  margin: 0 18px;
  font-size: 14px;
  color: var(--color-text);
  border-bottom: 1px solid rgba(var(--color-text-rgb), 0.1);
  max-width: 250px;
  line-height: 1.2;

  svg {
    color: #f0ad4e;
    flex-shrink: 0;
  }
`;
